var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.levelOfCare)?_c('div',{staticClass:"eoc-loc badge text-white",style:({ backgroundColor: _vm.levelOfCare.color })},[_vm._v("\n  "+_vm._s(_vm.levelOfCare.name)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }